// extracted by mini-css-extract-plugin
export var adjacentSlide = "_qr-9";
export var arrowButtonContainer = "_qr-5";
export var arrowButtonIcon = "_qr-6";
export var carouselArrowButton = "_qr-2";
export var carouselElementContainer = "_qr-1";
export var currentSlide = "_qr-8";
export var left = "_qr-3";
export var otherSlide = "_qr-a";
export var productCarouselContainer = "_qr-0";
export var right = "_qr-4";
export var sliderOverflow = "_qr-7";